import React, { useContext, useState } from "react";
import OTPicon from "../../assets/img/otpicon.png";
import { PrimaryButton } from "../button";
import {
  AuthModel,
  PaymentContext,
  PaymentContextValue,
  PaymentStage,
  PaymentStatus,
} from "../../contexts/Payment/payment.context";
import Input from "../input";
import { authorizeOtpCharge } from "../../services/api.services";
import { removeNonDigit, getAPIErrorMessage } from "../../utils/helpers";
import { useViewContext } from "../../contexts/view.context";
import { usePayDataContext } from "../../contexts/PayDataContext";

export default function CardOtp() {
  const {
    state,
    setState,
    setStage,
    setError,
    onInputChange,
    setPaymentReference,
  }: PaymentContextValue = useContext(PaymentContext);
  const [loading, setLoading] = useState(false);
  const { view, setView } = useViewContext();
  const { payReference, merchantData } = usePayDataContext();

  const changeView = async (e) => {
    e.preventDefault();
    setView("card");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    const payload = {
      otp: state.card.otp,
      reference: payReference,
      transaction_reference: state.charge.reference,
    };

    try {
      const charge = await authorizeOtpCharge(payload);
      const { auth_model, status, message } = charge;
      let stage = PaymentStage.auth_otp;

      setState({ charge });
      setLoading(false);
      console.log(status, "ststus", charge, "charge");
      if (status === "Successful") {
        setPaymentReference(charge.reference);
        setView("success");
        window.parent.postMessage(
          {
            action: "successful",
            data: {
              status: true,
              message: "Transaction was successful.",
              data: {
                status: "successful",
                reference: charge.reference,
              },
            },
          },
          "*"
        );

        if (merchantData.meta.redirect_url) {
          setTimeout(() => {
            window.location.href = merchantData.meta.redirect_url;
          }, 2000);
        }
      }
      if (status === "Failed") {
        setView("error");
      }
    } catch (e) {
      setError(getAPIErrorMessage(e));
      setLoading(false);
    }

    setLoading(false);
  };

  return (
    <div className="otpView">
      <p className="mt-5 text-center">
        Please enter the OTP sent to the mobile number
        <br /> or email address registered with your bank to complete this
        transaction.
      </p>
      <div className="mt-5 w-full flex justify-center">
        <img src={OTPicon} alt="otpicon" />
      </div>
      <form onSubmit={handleSubmit}>
        <div className="flex items-center mt-5 justify-between w-full">
          <div className="otpInputClass">
            <Input
              name={"otp"}
              type="text"
              inputMode={"numeric"}
              placeholder={"******"}
              title={""}
              value={state.card.otp}
              onChange={(e) => {
                const value = removeNonDigit(e.target.value.trim());
                onInputChange({
                  target: {
                    name: "otp",
                    value,
                  },
                });
              }}
              minLength={6}
              maxLength={8}
              inputClass={"text-center"}
            />
          </div>

          <div className="authorizeButton">
            <PrimaryButton
              loading={loading}
              className="mt-1"
              disabled={
                state.card.otp.length !== 6 || isNaN(parseInt(state.card.otp))
              }
              text={"Authorize"}
              id="authorize-otp"
            />
          </div>
        </div>
      </form>
      <h6 className="text-center mt-5 Inter-Semibold">
        Your bank might be having trouble sending a <br />
        token.
      </h6>
      {/* <div className="flex justify-center mt-5 resendOtp">
        <button  className="font-light" onClick={handleSubmit}>
          Resend OTP?
        </button>
      </div> */}
    </div>
  );
}
